/*
 * Public API Surface of ngx-ckeditor
 */

export * from './lib/ck-editor.component';
export * from './lib/ck-editor.module';
